export default "__VITE_ASSET__CfdqTDKG__"